import { render, staticRenderFns } from "./PurchaseCreateEdit.vue?vue&type=template&id=c1505158"
import script from "./PurchaseCreateEdit.vue?vue&type=script&lang=js"
export * from "./PurchaseCreateEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports